import axios from 'axios';

export const docentesApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/docentes`
});